import { FC, useState } from 'react';

import Cms from '../cms/Cms';
import Discounts from '../discounts/Discounts';
import GroupPage, { GroupSection } from './GroupPage';
import TillPreview, { Preview } from './TillPreview';

type CatalogPageProps = {
  /** The section named in the URL, if any. */
  section: string | null;
  /** Point the URL at one of this page's sections. */
  onSectionChange: (section: string) => void;
  onExit: () => void;
  onUnauthorized: () => void;
};

const JUMPS = [
  { id: 'items', label: 'Items' },
  { id: 'bundles', label: 'Bundles' },
];

/** What you sell: the catalogue on the till, and the bundles that price it. */
const CatalogPage: FC<CatalogPageProps> = ({ section, onSectionChange, onExit, onUnauthorized }) => {
  // Kept apart by section: both sections are mounted at once, so a shared slot
  // would let whichever published last decide what the rail shows.
  const [categoryPreview, setCategoryPreview] = useState<Preview | null>(null);
  const [bundlePreview, setBundlePreview] = useState<Preview | null>(null);
  const current = JUMPS.some((jump) => jump.id === section) ? section! : 'items';

  return (
    <GroupPage
      className="catalogPage"
      title="Catalog"
      subtitle="The items the till offers, and the bundles that sell them together for less."
      jumps={JUMPS}
      hashPrefix="catalog"
      activeHash={'#catalog-' + current}
      scrollTo={section}
      onSectionNavigate={onSectionChange}
      onExit={onExit}
      aside={<TillPreview preview={current === 'bundles' ? bundlePreview : categoryPreview} />}
    >
      <GroupSection id="items" hashPrefix="catalog" label="Items">
        <Cms onUnauthorized={onUnauthorized} onPreview={setCategoryPreview} />
      </GroupSection>
      <GroupSection id="bundles" hashPrefix="catalog" label="Bundles">
        <Discounts onUnauthorized={onUnauthorized} onPreview={setBundlePreview} />
      </GroupSection>
    </GroupPage>
  );
};

export default CatalogPage;
